import angular from "angular";

let LastLogOptions = function (gettextCatalog) {
    let getColumnDefs = () => {
        return [
            {headerName: 'User', field: 'ownerId', hide: true},
            {headerName: gettextCatalog.getString('Event'), field: 'event', suppressFilter: true, width: 110},
            {
                headerName: gettextCatalog.getString('Context'),
                field: "context",
                suppressFilter: true,
                valueFormatter: function (data) {
                    if (data && data.value)
                        return data.value.split('\\').pop();
                    return data
                },
                width: 110
            }, {
                headerName: gettextCatalog.getString('Date'),
                field: "createdAt",
                suppressFilter: true,
                valueFormatter: function (data) {
                    if (data && data.value)
                        return (new Date(data.value)).toLocaleString();

                    return data
                }
            },
        ];
    };
    return {
        _columnDefsCallback: getColumnDefs,
        enableFilter: false,
        floatingFilter: false,
        hideItemsPageSelect: true,
        paginationPageSize: 10,
        autoHeight: true,
        height: 300
    };

};

export default angular.module('cms.user.last_log', []).factory('LastLogOptions', LastLogOptions).name;




// WEBPACK FOOTER //
// ./src/cmsPages/Users/LastLogOptions.js